module.exports = __webpack_public_path__ + "static/media/13.6961ef1b.jpg";